import { HeaderFooterLayout } from '../app';

/** Base layout for directory pages */
export const DirectoryLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <HeaderFooterLayout>
      <div className='min-h-[1280px] md:-mt-12 relative bg-white'>{children}</div>
    </HeaderFooterLayout>
  );
};
